import React, { useContext } from "react";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import EditCarousel from "../../../components/edit-carousel/EditCarousel";
import RecentFilesTable from "../../../components/recent-files-table/RecentFilesTable";
import { StoreContext } from "../../../store/StoreContext";
import SmuCarousel from "../../../utils/smu-carousel/SmuCarousel";

const Home = () => {
  const { lastFiles, banners } = useContext(StoreContext);

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <EditCarousel show={showModal} onHide={() => setShowModal(false)} />

      <Row>
        <Col col={12} className="col-12 mb-4">
          <SmuCarousel
            isEdit={true}
            onEdit={() => setShowModal(true)}
            banners={banners}
          />
        </Col>
      </Row>
      <Row>
        <Col col={12} className="col-12 mb-4">
          <RecentFilesTable files={lastFiles} />
        </Col>
      </Row>
    </>
  );
};

export default Home;
